import { getOptionFunc } from '../state';
export const getThemeColor = (options) => {
    const getOption = getOptionFunc(options);
    return getOption('themeOption') === 'dark' ? '#364045' : '#FFFFFF';
};
